export default __webpack_public_path__ + "static/media/mastercard.35c38ecd.svg";